<template>
  <div class="feedback-widget">
    <el-button
      class="feedback-fab"
      type="primary"
      round
      icon="el-icon-chat-dot-round"
      @click="openDialog"
    >
      反馈
    </el-button>

    <el-dialog
      title="意见反馈"
      :visible.sync="dialogVisible"
      width="480px"
      append-to-body
      @closed="onDialogClosed"
    >
      <p class="feedback-intro">
        欢迎提出产品建议或问题描述，我们会尽快查看。
        每位用户每小时最多提交 10 条，请尽量一次描述清楚。
      </p>
      <el-form label-position="top">
        <el-form-item label="反馈内容" required>
          <el-input
            v-model="form.content"
            type="textarea"
            :rows="5"
            :maxlength="contentMax"
            show-word-limit
            placeholder="请描述您的建议、遇到的问题或期望改进的功能（至少 5 字）…"
          />
        </el-form-item>
        <el-form-item label="联系方式（选填）">
          <el-input
            v-model="form.contact"
            :maxlength="contactMax"
            placeholder="邮箱 / 微信，便于我们回复您"
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitting" :disabled="cooldownSec > 0" @click="handleSubmit">
          {{ cooldownSec > 0 ? `请 ${cooldownSec}s 后再提交` : '提交' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { submitFeedback } from '../api/feedback';
import {
  FEEDBACK_CLIENT_COOLDOWN_SEC,
  FEEDBACK_CONTACT_MAX,
  FEEDBACK_CONTENT_MAX,
  FEEDBACK_CONTENT_MIN,
  getFeedbackCooldownRemainingSec,
  markFeedbackSubmitted,
} from '../constants/feedbackLimits';

export default {
  name: 'FeedbackWidget',
  data() {
    return {
      dialogVisible: false,
      submitting: false,
      cooldownSec: 0,
      cooldownTimer: null,
      contentMax: FEEDBACK_CONTENT_MAX,
      contactMax: FEEDBACK_CONTACT_MAX,
      form: {
        content: '',
        contact: '',
      },
    };
  },
  beforeDestroy() {
    this.clearCooldownTimer();
  },
  methods: {
    openDialog() {
      this.syncCooldown();
      this.dialogVisible = true;
    },
    onDialogClosed() {
      if (!this.submitting) {
        this.form.content = '';
        this.form.contact = '';
      }
      this.clearCooldownTimer();
    },
    syncCooldown() {
      this.cooldownSec = getFeedbackCooldownRemainingSec();
      this.clearCooldownTimer();
      if (this.cooldownSec > 0) {
        this.cooldownTimer = setInterval(() => {
          this.cooldownSec = getFeedbackCooldownRemainingSec();
          if (this.cooldownSec <= 0) {
            this.clearCooldownTimer();
          }
        }, 1000);
      }
    },
    clearCooldownTimer() {
      if (this.cooldownTimer) {
        clearInterval(this.cooldownTimer);
        this.cooldownTimer = null;
      }
    },
    async handleSubmit() {
      const content = (this.form.content || '').trim();
      if (content.length < FEEDBACK_CONTENT_MIN) {
        this.$message.warning(`反馈内容至少 ${FEEDBACK_CONTENT_MIN} 个字`);
        return;
      }
      if (content.length > FEEDBACK_CONTENT_MAX) {
        this.$message.warning(`反馈内容不超过 ${FEEDBACK_CONTENT_MAX} 字`);
        return;
      }
      const remaining = getFeedbackCooldownRemainingSec();
      if (remaining > 0) {
        this.cooldownSec = remaining;
        this.$message.warning(`提交过于频繁，请 ${remaining} 秒后再试`);
        return;
      }
      this.submitting = true;
      try {
        await submitFeedback({
          content,
          contact: (this.form.contact || '').trim().slice(0, FEEDBACK_CONTACT_MAX) || undefined,
          pageUrl: typeof window !== 'undefined' ? window.location.href.slice(0, 512) : undefined,
        });
        markFeedbackSubmitted();
        this.syncCooldown();
        this.$message.success('感谢反馈，我们已收到');
        this.dialogVisible = false;
        this.form.content = '';
        this.form.contact = '';
      } catch (e) {
        this.$message.error(e.message || '提交失败');
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style scoped>
.feedback-fab {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 2000;
  box-shadow: 0 4px 14px rgba(15, 118, 110, 0.45);
}
.feedback-intro {
  margin: 0 0 12px;
  font-size: 13px;
  color: #6b7280;
  line-height: 1.5;
}
</style>
